import { render } from "./Number.vue?vue&type=template&id=510dc9ba"
import script from "./Number.vue?vue&type=script&lang=js"
export * from "./Number.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/ardia/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__